'use client';

interface PromotionCheckpoint {
  min_purchase: number;
  reached: boolean;
  remaining: number;
  reward: string;
}

interface PurchaseProgressProps {
  checkpoints: PromotionCheckpoint[];
  currentAmount?: number;
}

export default function ProgressShippingCheckpoints({ checkpoints, currentAmount = 0 }: PurchaseProgressProps) {
  const sortedCheckpoints = [...checkpoints].sort((a, b) => a.min_purchase - b.min_purchase);

  // Compute current step
  const currentStep = sortedCheckpoints.find(cp => !cp.reached) || sortedCheckpoints[sortedCheckpoints.length - 1];
  const maxPurchase = sortedCheckpoints[sortedCheckpoints.length - 1]?.min_purchase || 1;

  return (
    <div className="w-full max-w-2xl mx-auto p-4 relative">
      {/* Status Summary */}
      <div className="text-center text-sm text-gray-700 mb-4">
        {currentStep.reached ? (
          <span className="text-green-700 font-semibold">
            {currentStep.reward.toLowerCase().includes('free') ? (
              <>🎉 You’ve unlocked <strong>{currentStep.reward}</strong>!</>
            ) : (
              <>🥳 Congrats! You’ve earned a <strong>{currentStep.reward}</strong>!</>
            )}
          </span>
        ) : (
          <span className="text-yellow-700 font-medium">
            {currentStep.reward.toLowerCase().includes('discount') ? (
              <>🛍️ Only <strong>Rp{currentStep.remaining.toLocaleString()}</strong> more to unlock a <strong>{currentStep.reward}</strong>!</>
            ) : (
              <>🚚 Spend <strong>Rp{currentStep.remaining.toLocaleString()}</strong> more to enjoy <strong>{currentStep.reward}</strong>!</>
            )}
          </span>
        )}
        <div className="text-xs text-gray-500 mt-1">Current total: Rp{currentAmount.toLocaleString()}</div>
      </div>


      {/* Progress Bar */}
      <div className="relative w-full h-3 bg-gray-200 rounded-full overflow-hidden mb-6">
        <div
          className="h-full bg-yellow-400 transition-all duration-500"
          style={{
            width: `${Math.min((currentAmount / maxPurchase) * 100, 100)}%`,
          }}
        />
        {sortedCheckpoints.map((cp, index) => (
          <div
            key={index}
            className="absolute top-0 -translate-x-1/2 h-3 w-[2px] bg-white"
            style={{
              left: `${(cp.min_purchase / maxPurchase) * 100}%`,
            }}
          />
        ))}
      </div>

      {/* Step Labels */}
      <div className="flex justify-between text-xs text-gray-600 px-1">
        {sortedCheckpoints.map((cp, index) => (
          <span key={index} className="text-center w-1/4">
            {cp.reward}
          </span>
        ))}
      </div>
    </div>
  );
}
